// eslint-disable-next-line tap/no-raw-text-js
export const ReportingFieldAliasesRoute = {
  // eslint-disable-next-line tap/no-raw-text-js
  FIELD_ALIASES: '/reporting/field-aliases',
};

// eslint-disable-next-line tap/no-raw-text-js
export const ReportingFieldAliasesName = {
  // eslint-disable-next-line tap/no-raw-text-js
  FIELD_ALIASES: 'reporting-field-aliases',
};

export const ALIAS_ENTITY_TYPE_TABS = [
  // eslint-disable-next-line tap/no-raw-text-js
  { key: 'order', label: 'Orders' },
  // eslint-disable-next-line tap/no-raw-text-js
  { key: 'line_item', label: 'Line Items' },
  // eslint-disable-next-line tap/no-raw-text-js
  { key: 'flight', label: 'Flights' },
  // eslint-disable-next-line tap/no-raw-text-js
  { key: 'task', label: 'Tasks' },
];
